import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ObjectModel} from '../../shared/models/object.model';

@Injectable({
  providedIn: 'root'
})
export class ShareService {
  showShareManagerForObject$: BehaviorSubject<ObjectModel> = new BehaviorSubject<ObjectModel>(null);
}
